export class GcpVaultConfigInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucketName",
            "baseName": "bucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionKey",
            "baseName": "encryptionKey",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpVaultConfigInput.attributeTypeMap;
    }
    constructor() {
    }
}
